import AppHeader from '../AppHeader'

export default {
  name: 'shift-manage',
  computed: {
    isClerk () {
      return this.$store.getters.clerk
    },
    isShiftCreator () {
      return this.$store.getters.shiftCreator
    },
    isShopMaster () {
      return this.$store.getters.shopMaster
    }
  },
  components: {
    AppHeader
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shift-manage.js